import { SupplementAgreementRegion } from "src/app/fees-management/supplement-agreement/supplement-agreement.consts";

export const LEGAL_JURISDICTIONS = [
  { id: 'Austria', displayValue: 'Austria', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  { id: 'Germany', displayValue: 'Germany', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  { id: 'Ireland', displayValue: 'Ireland', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  { id: 'Israel', displayValue: 'Israel', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  { id: 'Netherlands', displayValue: 'Netherlands', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  { id: 'Norway', displayValue: 'Norway', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  {
    id: 'Russian Federation',
    displayValue: 'Russian Federation',
    category: 'Most common', region: SupplementAgreementRegion.EMEA,
  },
  { id: 'South Africa', displayValue: 'South Africa', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  { id: 'Sweden', displayValue: 'Sweden', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  { id: 'Switzerland', displayValue: 'Switzerland', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  { id: 'United Kingdom', displayValue: 'UK', category: 'Most common', region: SupplementAgreementRegion.EMEA },
  {
    id: 'United Arab Emirates',
    displayValue: 'United Arab Emirates',
    category: 'Most common', region: SupplementAgreementRegion.EMEA,
  },

  { id: 'Austria', displayValue: 'Austria', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Belgium', displayValue: 'Belgium', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Denmark', displayValue: 'Denmark', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Finland', displayValue: 'Finland', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'France', displayValue: 'France', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Germany', displayValue: 'Germany', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Ireland', displayValue: 'Ireland', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Italy', displayValue: 'Italy', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Jersey', displayValue: 'Jersey', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Luxembourg', displayValue: 'Luxembourg', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Malta', displayValue: 'Malta', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Monaco', displayValue: 'Monaco', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Netherlands', displayValue: 'Netherlands', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Norway', displayValue: 'Norway', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Portugal', displayValue: 'Portugal', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'South Africa', displayValue: 'South Africa', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Spain', displayValue: 'Spain', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Sweden', displayValue: 'Sweden', category: 'EMEA', region: SupplementAgreementRegion.EMEA },
  { id: 'Switzerland', displayValue: 'Switzerland', category: 'EMEA', region: SupplementAgreementRegion.EMEA },

  { id: 'Australia', displayValue: 'Australia', category: 'Asia Pacific', region: SupplementAgreementRegion.A_NZ },
  { id: 'China', displayValue: 'China', category: 'Asia Pacific', region: SupplementAgreementRegion.ASIA_PAC },
  { id: 'Hong Kong', displayValue: 'Hong Kong', category: 'Asia Pacific', region: SupplementAgreementRegion.ASIA_PAC },
  { id: 'India', displayValue: 'India', category: 'Asia Pacific', region: SupplementAgreementRegion.ASIA_PAC },
  { id: 'Japan', displayValue: 'Japan', category: 'Asia Pacific', region: SupplementAgreementRegion.JAPAN },
  { id: 'Singapore', displayValue: 'Singapore', category: 'Asia Pacific', region: SupplementAgreementRegion.ASIA_PAC },

  { id: 'Canada', displayValue: 'Canada', category: 'Americas', region: SupplementAgreementRegion.AMERICAS },
  {
    id: 'United States of America',
    displayValue: 'United States of America',
    category: 'Americas', region: SupplementAgreementRegion.AMERICAS
  },
];
